module.exports = __webpack_public_path__ + "static/img/1.fb7eb79.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/sp/1.png
// module id = YiDu
// module chunks = 0